import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetResourceUsageOptions,
  GetResourceUsageResponse,
  getResourceUsage as universalGetResourceUsage,
} from './cloud-resourceusage-v1-resource-usage-data.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/data-resourceusage-service' };

export function getResourceUsage(
  httpClient: HttpClient
): GetResourceUsageSignature {
  return (options?: GetResourceUsageOptions) =>
    universalGetResourceUsage(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetResourceUsageSignature {
  /**
   * Get current Resource Usage
   */
  (options?: GetResourceUsageOptions): Promise<
    NonNullablePaths<
      GetResourceUsageResponse,
      | `resourceUsage.dataCollectionUsages`
      | `resourceUsage.dataCollectionUsages.${number}.dataCollectionId`
      | `resourceUsage.dataCollectionUsages.${number}.liveItemCount`
      | `resourceUsage.dataCollectionUsages.${number}.liveUsedStorageInBytes`
      | `resourceUsage.dataCollectionUsages.${number}.dataCollectionType`
      | `resourceUsage.dataCollectionUsages.${number}.deleted`,
      5
    >
  >;
}

export {
  ActionEvent,
  CollectionType,
  DataCollectionResourceUsage,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetResourceUsageOptions,
  GetResourceUsageRequest,
  GetResourceUsageResponse,
  ResourceUsage,
  RestoreInfo,
} from './cloud-resourceusage-v1-resource-usage-data.universal.js';
